import { zSchema, schemes } from "../../../schema-validation";
import { LEGAL_STRUCTURES } from "../../IOdoCompany";

const zAddress = zSchema.object({
  address: zSchema.string(),
  address_line2: zSchema.string().optional(),
  city: zSchema.string(),
  state: zSchema.string(),
  zip: zSchema.string(),
});

export const companyOnboardSchema = zSchema.object({
  business_address: zAddress.shape.address,
  business_city: zAddress.shape.city,
  business_ein: zSchema.string(),
  business_name: zSchema.string(),
  business_phone: zSchema.string(),
  business_state: zAddress.shape.state,
  business_zip: zAddress.shape.zip,
  legal_structure: zSchema.enum(LEGAL_STRUCTURES),
  owner_address: zAddress.shape.address,
  owner_title: zSchema.string(),
  owner_city: zAddress.shape.city,
  owner_email: zSchema.string(),
  owner_first_name: zSchema.string(),
  owner_last_name: zSchema.string(),
  owner_ssn: schemes.ssn(),
  owner_state: zAddress.shape.state,
  owner_zip: zAddress.shape.zip,
  ownership_percentage: zSchema.number(),
  skip_account_creation: zSchema.boolean().default(false),
  uuid: zSchema.string(),
});
